import styled from 'styled-components'

const Container = styled.div`
  .adminForm--container {
    background: #fff;
    padding: 2rem;
    border-radius: 8px;
    max-width: 500px;
    margin: 0 auto;

    header {
      margin-bottom: 2rem;
      
      h2 {
        font-size: 1.25rem;
        margin-bottom: 0.5rem;
        color: #111827;
        font-weight: 600;
      }

      p {
        color: #6b7280;
        font-size: 0.875rem;
        margin-bottom: 1rem;
      }

      .progress-bar {
        width: 100%;
        height: 4px;
        background: #e5e7eb;
        border-radius: 2px;
        overflow: hidden;

        .progress-fill {
          height: 100%;
          background: ${({ theme }) => theme.primaryColor};
          transition: width 0.3s ease;
        }
      }
    }

    form {
      .input--group {
        margin-bottom: 1rem;

        label {
          color: #374151 !important;
          font-weight: 500 !important;
          font-size: 0.875rem !important;
        }

        input:not([type='checkbox']),
        select,
        textarea {
          background: #fff !important;
          border: 1px solid #d1d5db !important;
          color: #111827 !important;
          padding: 0.625rem 0.875rem !important;
          border-radius: 6px !important;
          font-size: 0.875rem !important;

          &::placeholder {
            color: #9ca3af !important;
          }

          &:focus {
            border-color: ${({ theme }) => theme.primaryColor} !important;
            outline: none !important;
            box-shadow: 0 0 0 3px ${({ theme }) => theme.primaryColor}15 !important;
          }
        }
      }

      .password-field {
        position: relative;

        .password-toggle {
          position: absolute;
          top: 56%;
          right: 0.75rem;
          transform: translateY(-50%);
          background: none;
          border: none;
          cursor: pointer;
          color: #6b7280;
          font-size: 1.125rem;
          padding: 0.25rem;

          &:hover {
            color: ${({ theme }) => theme.primaryColor};
          }
        }

        input {
          padding-right: 2.5rem !important;
        }
      }

      .error-message {
        color: #ef4444;
        font-size: 0.8125rem;
        margin-top: -0.75rem;
        margin-bottom: 0.75rem;
      }

      .form-step {
        min-height: 280px;

        h3 {
          font-size: 1rem;
          color: #111827;
          margin-bottom: 1.5rem;
          padding-bottom: 0.75rem;
          border-bottom: 1px solid #e5e7eb;
          font-weight: 600;
        }
      }

      .form-actions {
        display: flex;
        gap: 0.75rem;
        margin-top: 2rem;
        padding-top: 1.5rem;
        border-top: 1px solid #e5e7eb;

        button {
          flex: 1;
          padding: 0.625rem 1rem;
          border-radius: 6px;
          font-weight: 500;
          font-size: 0.875rem;
          border: none;
          cursor: pointer;

          &:not(.btn-secondary) {
            background: ${({ theme }) => theme.primaryColor};
            color: #fff;

            &:hover:not(:disabled) {
              opacity: 0.9;
            }

            &:disabled {
              opacity: 0.5;
              cursor: not-allowed;
            }
          }

          &.btn-secondary {
            background: #f3f4f6;
            color: #374151;

            &:hover {
              background: #e5e7eb;
            }
          }
        }
      }
    }
  }
`

export default Container
